import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import ReorderItems from '../reorderItems';
import { isArrayEmpty, reorder } from '../../../utility/helpers';
import Division from './division';
import NotificationCard from '../notificationCard';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  button: {
    borderRadius: 8,
    width: '100%',
    height: 40,
    minHeight: 40,
    backgroundColor: primary.bluish8,
    boxSizing: 'border-box',
    border: `1px solid ${primary.bluish6}`,
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: primary.bluish8,
    },
  },
}));

const Divisions = ({
  translations,
  divisions = [],
  canEdit,
  canDelete,
  onEditDivisionTitle = () => {},
  onDuplicateDivision = () => {},
  handleDeleteDivisionDialog = () => {},
  handleCreateDivision = () => {},
  handleCreateDepartment = () => {},
  onReorderDepartment = () => {},
  onReorderDivision = () => {},
}) => {
  const classes = useStyles();

  const handleReorder = useCallback(
    result => {
      if (
        !result.destination ||
        result.source.index === result.destination.index
      )
        return;

      const updatedOrder = reorder(
        divisions,
        result.source.index,
        result.destination.index
      );

      return onReorderDivision(updatedOrder);
    },
    [divisions, onReorderDivision]
  );

  return (
    <div>
      <ReorderItems onSave={handleReorder} isDragDisabled={!canEdit}>
        {divisions?.map(division => (
          <Division
            key={`division_group_${division.id}`}
            id={division.id}
            translations={translations}
            division={division}
            canEdit={canEdit}
            canDelete={canDelete}
            onEditDivisionTitle={onEditDivisionTitle}
            onDuplicateDivision={onDuplicateDivision}
            onReorderDepartment={onReorderDepartment}
            handleDeleteDivisionDialog={handleDeleteDivisionDialog}
            handleCreateDepartment={handleCreateDepartment}
          />
        ))}
      </ReorderItems>
      {canEdit && (
        <CustomButton
          className={classes.button}
          type="addWithTextDarkNewLarge"
          onClick={handleCreateDivision}
        >
          {translations.createDivisionButton}
        </CustomButton>
      )}
      {!canEdit && isArrayEmpty(divisions) && (
        <NotificationCard
          title={translations.noResults.title}
          content={translations.noResults.content}
        />
      )}
    </div>
  );
};

Divisions.propTypes = {
  translations: PropTypes.object.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.object),
  canEdit: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  onEditDivisionTitle: PropTypes.func,
  onDuplicateDivision: PropTypes.func,
  handleCreateDivision: PropTypes.func,
  handleCreateDepartment: PropTypes.func,
  handleDeleteDivisionDialog: PropTypes.func,
  onReorderDepartment: PropTypes.func,
  onReorderDivision: PropTypes.func,
};

export default Divisions;
